import React, { useEffect, useState } from "react";
import DatatableComponent from "./datatable.component";
import { showToast } from "src/utils";
import { TOASTR_TYPES } from "src/components/atoms/toast-container/types";
import { useSearchParams } from "react-router-dom";
import useLoadingError from "src/hooks/useLoadingError";
import { useAddCostGroupMutation } from "src/services/api-service/margin-groups";
import { useFormik } from "formik";
import { IResponse } from "src/services/types";
import { costGroupSchema } from "src/validations/cost-group-schema";
import useTitleCase from "src/hooks/useTitleCase";

const DatatableContainer = () => {
  const [url] = useSearchParams();
  const marginGroupId = url?.get("id");
  const marginGroupName: string = url?.get("name") ?? "";

  const { loading, error, reset, startLoading, stopLoading } =
    useLoadingError();
  const [addItem] = useAddCostGroupMutation<any>();
  const [id, setId] = useState("");
  const [closeModal, setCloseModal] = useState(false);
  const [reFetchData, setReFetchData] = useState(false);
  const { titleCasedString, handleInputChange } = useTitleCase();

  const formik = useFormik({
    initialValues: {
      name: marginGroupName,
      newCustomerIds: [],
    },
    validationSchema: costGroupSchema,
    validateOnBlur: true,
    validateOnChange: true,
    validateOnMount: true,
    onSubmit: (values) => {
      setReFetchData(false);
      setCloseModal(false);
      startLoading();
      let APIHIT;
      !id &&
        (APIHIT = addItem({
          ...values,
          name: titleCasedString?.name || formik?.values?.name,
          newCustomerIds: JSON.stringify(formik?.values?.newCustomerIds),
          id: marginGroupId,
        }));
      setId("");
      APIHIT &&
        APIHIT.unwrap()
          .then((data) => {
            setReFetchData(true);
            setCloseModal(true);
            showToast(TOASTR_TYPES.SUCCESS, data?.message);
          })
          .catch((err: IResponse) => {
            console.log(err);
          })
          .finally(() => {
            stopLoading();
          });
    },
  });

  useEffect(() => {
    handleInputChange(formik.values.name, "name");
  }, [formik.values.name]);

  const getCurrentId = (id: string) => {
    setCloseModal(false);
    setId(id);
  };

  const setCloseModalState = (value: boolean) => {
    setCloseModal(value);
  };

  return (
    <DatatableComponent
      formik={formik}
      error={error}
      resetError={reset}
      loading={loading}
      getId={getCurrentId}
      closeModal={closeModal}
      setCloseModal={setCloseModalState}
      reFetchData={reFetchData}
    />
  );
};

export default DatatableContainer;
